import newsSeoCore from './newsSeoCore';

const {
  SITE_URL,
  DEFAULT_IMAGE,
  cleanObject,
  createDescription,
  createNewsSeoData,
  getCategoryLink,
  resolveNewsImage,
  stripHtml,
  toIsoDate,
} = newsSeoCore;

const requiredFunctions = {
  cleanObject,
  createDescription,
  createNewsSeoData,
  getCategoryLink,
  resolveNewsImage,
  stripHtml,
  toIsoDate,
};

Object.entries(requiredFunctions).forEach(([name, value]) => {
  if (typeof value !== 'function') {
    throw new TypeError(`newsSeoCore must export ${name} as a function`);
  }
});

export {
  SITE_URL,
  DEFAULT_IMAGE,
  cleanObject,
  createDescription,
  createNewsSeoData,
  getCategoryLink,
  resolveNewsImage,
  stripHtml,
  toIsoDate,
};
